// https://codesandbox.io/p/sandbox/react-triple-toggle-forked-lpk2i5?file=%2Fsrc%2Ftriple.js

import React, { useRef, useState } from "react";
import styles from "./TriStateSwitch.module.css";
// import "./styles.css";

const defaultOnChange = (value) => console.log("[TriStateSwitch] value:", value);

const TriStateSwitch = (props) => {
  const [switchPosition, setSwitchPosition] = useState( props.initialPosition || "center" );
  const [animation, setAnimation] = useState( null );

  const getSwitchAnimation = (value) => {
    const newAnimation = (value != switchPosition) ? `${switchPosition}_to_${value}` : null;
 
    props.onChange ? props.onChange( props.labels?.[value]?.value || value ) : defaultOnChange( value );
    setSwitchPosition( value );
    setAnimation( newAnimation );
  };

  const TTSButton = ({id, pos, label}) => {
    return <>
      <input
        className={styles[pos]}
        onChange={(e) => getSwitchAnimation(e.target.value)}
        name={props.id || 'map-switch'}
        id={`${id}_${pos}`}
        type="radio"
        value={pos}
      />
      <label
        className={[styles.label_style, styles[`${pos}_label`], (switchPosition === pos ? styles.black_font : null)].join(' ')}
        htmlFor={`${id}_${pos}`}
      >
        <div className={styles.h4_style}>{label || pos}</div>
      </label>
    </>
  }

  return (
    <div className={styles.main}>
      <div
        className={[styles.switch, styles[animation], styles[`${switchPosition}_position`]].join(' ')}
      ></div>

      <TTSButton pos="left"   id={props.id} label={props.labels?.left?.title} />
      <TTSButton pos="center" id={props.id} label={props.labels?.center?.title} />
      <TTSButton pos="right"  id={props.id} label={props.labels?.right?.title} />

    </div>
  );
}

export default TriStateSwitch;
